/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

/**
 * Statistics by task level (level_1, level_2, level_3)
 */
export type StudentProgressReportLevelStats = { [key: string]: { [key: string]: number } };
